import { gql } from '@apollo/client';

export const createReview = gql`
  mutation CreateReview($input: CreateReviewInput!, $condition: ModelReviewConditionInput) {
    createReview(input: $input, condition: $condition) {
      id
      rating
      content
      communicationRating
      reviewerId
      revieweeId
      studioId
      reviewType
      bookingId
      createdAt
      reviewer {
        id
        firstName
        profilePicture
      }
    }
  }
`;

// Secure backend path: creates the review and marks the booking in one transaction.
export const CREATE_REVIEW_SECURE = gql`
  mutation CreateReviewSecure($input: MarkBookingReviewedInput!) {
    markBookingReviewed(input: $input) {
      id
      status
      hostReviewed
      guestReviewed
      updatedAt
      reviewId
      review {
        id
        rating
        content
        communicationRating
        reviewerId
        revieweeId
        studioId
        reviewType
        bookingId
        createdAt
        reviewer {
          id
          firstName
          profilePicture
        }
      }
    }
  }
`;

export const CREATE_REVIEW = gql`
  mutation CreateReview($input: CreateReviewInput!, $condition: ModelReviewConditionInput) {
    createReview(input: $input, condition: $condition) {
      id
      rating
      content
      communicationRating
      reviewerId
      reviewer {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      revieweeId
      reviewee {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      studioId
      studio {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        image
        description
        userID
        studioTypes
        tagValues
        studioSize
        numberOfPeople
        city
        postcode
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        amenities
        tags {
          nextToken
          __typename
        }
        equipment {
          nextToken
          __typename
        }
        availabilities {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        blockedTimes {
          nextToken
          __typename
        }
        wishListStudios {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      reviewType
      bookingId
      booking {
        id
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        Studio {
          id
          StudioName
          images
          studioLocation
          pricePerHour
          image
          description
          userID
          studioTypes
          tagValues
          studioSize
          numberOfPeople
          city
          postcode
          country
          approxLatitude
          approxLongitude
          locationLabel
          locationPrecision
          minNumberOfHours
          amenities
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        paymentStatus
        paymentIntentID
        guestReviewed
        hostReviewed
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const UPDATE_REVIEW = gql`
  mutation UpdateReview($input: UpdateReviewInput!, $condition: ModelReviewConditionInput) {
    updateReview(input: $input, condition: $condition) {
      id
      rating
      content
      communicationRating
      reviewerId
      reviewer {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      revieweeId
      reviewee {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      studioId
      studio {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        image
        description
        userID
        studioTypes
        tagValues
        studioSize
        numberOfPeople
        city
        postcode
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        amenities
        tags {
          nextToken
          __typename
        }
        equipment {
          nextToken
          __typename
        }
        availabilities {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        blockedTimes {
          nextToken
          __typename
        }
        wishListStudios {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      reviewType
      bookingId
      booking {
        id
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        Studio {
          id
          StudioName
          images
          studioLocation
          pricePerHour
          image
          description
          userID
          studioTypes
          tagValues
          studioSize
          numberOfPeople
          city
          postcode
          country
          approxLatitude
          approxLongitude
          locationLabel
          locationPrecision
          minNumberOfHours
          amenities
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        paymentStatus
        paymentIntentID
        guestReviewed
        hostReviewed
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_REVIEW = gql`
  mutation DeleteReview($input: DeleteReviewInput!, $condition: ModelReviewConditionInput) {
    deleteReview(input: $input, condition: $condition) {
      id
      rating
      content
      communicationRating
      reviewerId
      reviewer {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      revieweeId
      reviewee {
        id
        firstName
        lastName
        profilePicture
        numberOfStudios
        Studios {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishLists {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        userChatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviewsReceived {
          nextToken
          __typename
        }
        reviewsGiven {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      studioId
      studio {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        image
        description
        userID
        studioTypes
        tagValues
        studioSize
        numberOfPeople
        city
        postcode
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        amenities
        tags {
          nextToken
          __typename
        }
        equipment {
          nextToken
          __typename
        }
        availabilities {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        blockedTimes {
          nextToken
          __typename
        }
        wishListStudios {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        averageRating
        reviewCount
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      reviewType
      bookingId
      booking {
        id
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        Studio {
          id
          StudioName
          images
          studioLocation
          pricePerHour
          image
          description
          userID
          studioTypes
          tagValues
          studioSize
          numberOfPeople
          city
          postcode
          country
          approxLatitude
          approxLongitude
          locationLabel
          locationPrecision
          minNumberOfHours
          amenities
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          averageRating
          reviewCount
          createdAt
          updatedAt
          __typename
        }
        paymentStatus
        paymentIntentID
        guestReviewed
        hostReviewed
        reviews {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getStudioReviews = gql`
  query GetStudioReviews($studioId: ID!, $limit: Int, $nextToken: String) {
    listReviews(filter: {studioId: {eq: $studioId}, reviewType: {eq: HOST_REVIEW}}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        rating
        content
        communicationRating
        createdAt
        reviewerId
        reviewer {
          id
          firstName
          profilePicture
        }
      }
      nextToken
    }
  }
`;
